import styled from 'styled-components';

const CenteredPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default CenteredPageContainer;



// WEBPACK FOOTER //
// ./src/components/CenteredPageContainer.tsx